import { FC } from 'react'
import { redirectLogout } from '..'
import { Warning } from '../../../components/warning'

const WithoutAccess: FC = (): React.ReactElement => {
  return (
    <Warning
      icon='lock'
      title='Você não tem acesso à plataforma TP Digital'
      description='Requisite o seu acesso ao administrador e em seguida reinicie sua sessão para que as permissões sejam atualizadas.'
      label='Sair'
      ariaLabel='Encerrar sessão'
      onResolve={redirectLogout}
    />
  )
}

export default WithoutAccess
